const statsMeta = {
  permissionInfo: {
    key: "statistic",
    region: true,
  },
};

export default [
  {
    path: "/stats/v1",
    component: () => import("$views/Stats/v1"),
    children: [
      { path: "", redirect: "daily" },
      {
        path: "daily",
        component: () => import("$views/Stats/v1/Total.Daily"),
        meta: statsMeta,
      },
      {
        path: "monthly",
        component: () => import("$views/Stats/v1/Total.Monthly"),
        meta: statsMeta,
      },
      {
        path: "brain",
        component: () => import("$views/Stats/v1/BrainMotion"),
        meta: statsMeta,
      },
      {
        path: "health",
        component: () => import("$views/Stats/v1/Health"),
        meta: statsMeta,
      },
      {
        path: "target/:id",
        component: () => import("$views/Stats/v1/Target.Detail"),
        meta: statsMeta,
      },
      {
        path: "target",
        component: () => import("$views/Stats/v1/Target"),
        meta: statsMeta,
      },
    ],
  },
];
